/**
 * this is the actual application where all daisy modules inherit from
 **/
export default class DaisyController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $scope) {
		this.Socket = $injector.get('socket');
		this.ToastService = $injector.get('ToastService');
		this.$storage = $injector.get('$localStorage');
		this.$session = $injector.get('$sessionStorage');
		this.LocationService = $injector.get('LocationService');
		this.UnitService = $injector.get('UnitService');
	}

	/**
	 * initialize the component and register some event listeners to check for new users
	 **/
	$onInit() {
		this.registerEvents();
		this.requestUnits();
		this.requestLocations();
	}

	registerEvents() {
		this.Socket.on('socket:login:newUser', (data) => {
			this.ToastService.toast(data.FULLNAME+' ist online.');
		});
	}

	requestLocations() {
		this.LocationService.getLocations()
			.then((response) => {
				this.$storage.locations = response;
			})
			.catch((err) => {
				this.ToastService.danger('Fehler beim Laden der Standorte. ' + err.statusText);
			});
	}

	requestUnits() {
		this.UnitService.getUnits()
			.then((response) => {
				this.$storage.units = response;
			})
			.catch((err) => {
				ToastService.danger('Fehler beim Laden der Mengeneinheiten. ' + err.statusText);
			});
	}

	unregisterEvents() {
		this.Socket.removeAllListeners('socket:login:newUser');
		this.Socket.removeAllListeners('socket:version:checkAppVersion');
		this.Socket.removeAllListeners('socket:version:versionOutdated');
		this.Socket.removeAllListeners('socket:message:show');
	}

	/**
	 * remove all registered listeneres on destroy
	 **/
	$onDestroy() {
		this.unregisterEvents();
	}

	/**
	 * static method to check if the user is authenticated
	 * @param {function} - $injector to inject all services
	 * @param {string} [path="Login"] - the path to navigate to if the user is not authenticated
	 * @return {promise} with true/false
	 **/
	static $canActivate($injector, path = 'Login') {
		return true;
	}

}
